import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownHotelServices', request)
}

export {get}
